import React from 'react';
import { s as styleInject } from './index-7f1490f0.js';

/* eslint-disable */
ace.define("ace/theme/prism", ["require", "exports", "module", "ace/lib/dom"], function (acequire, exports, module) {
  exports.isDark = false;
  exports.cssClass = "ace-prism";
  exports.cssText = ".ace-prism .ace_gutter {\
background: #f5f2f0;\
color: black\
}\
.ace-prism {\
font: 13px/normal 'Menlo', 'Monaco', 'Consolas', 'Courier New', 'Ubuntu Mono', 'source-code-pro', monospace;\
}\
.ace-prism .ace_print-margin {\
width: 1px;\
background: #e8e8e8\
}\
.ace-prism {\
background-color: #ffffff;\
color: black\
}\
.ace-prism .ace_cursor {\
color: #000000\
}\
.ace-prism .ace_marker-layer .ace_selection {\
background: rgba(179, 212, 252, 1)\
}\
.ace-prism.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px rgba(179, 212, 252, 1);\
}\
.ace-prism .ace_marker-layer .ace_step {\
background: rgb(255, 255, 0)\
}\
.ace-prism .ace_marker-layer .ace_bracket {\
margin: 2px 0px 0px 1px;\
border-bottom: 1px solid rgba(147, 161, 161, 1);\
border-radius: 0px;\
}\
.ace-prism .ace_marker-layer .ace_active-line {\
background: rgba(179, 212, 252, .25)\
}\
.ace-prism .ace_gutter-active-line {\
background-color : rgba(179, 212, 252, .75)\
}\
.ace-prism .ace_marker-layer .ace_selected-word {\
border: 1px solid rgba(147, 161, 161, 1);\
border-radius: 2px;\
}\
.ace-prism .ace_marker-layer .ace_selected-word + .ace_active-line {\
background: rgba(179, 212, 252, 0)\
}\
.ace-prism .ace_invisible {\
color: rgba(147, 161, 161, 0.50)\
}\
.ace-prism .ace_keyword,\
.ace-prism .ace_meta,\
.ace-prism .ace_support.ace_class,\
.ace-prism .ace_support.ace_type,\
.ace-prism .ace_storage {\
color: #07a\
}\
.ace-prism .ace_constant.ace_character,\
.ace-prism .ace_constant.ace_other {\
color: #690\
}\
.ace-prism .ace_constant.ace_language {\
color: #905\
}\
.ace-prism .ace_constant.ace_numeric {\
color: #905\
}\
.ace-prism .ace_fold {\
background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAGCAYAAACij5zfAAAAAXNSR0IArs4c6QAAAHhJREFUKBVjXNWgzfb3y/um/wwMcQxAwMjAsIiZR7AurOHqLxAfG6CmHhaI5f/LYRYBHVIOFANxK2Bi6DQ19TDBfI5sCTYxQvLk6mFCNngg2EygOEe3GJsYshps8tjEiNHDAkpwoDiHBSHIIJAYA8MzZP0obGrqAQC8L1sCNuNg0gAAAABJRU5ErkJggg==);\
background-size: 16px 3px;\
background-color: #FBB129;\
border-color: #A67419\
}\
.ace-prism .ace_entity.ace_name.ace_function,\
.ace-prism .ace_entity.ace_name.ace_tag,\
.ace-prism .ace_support.ace_function,\
.ace-prism .ace_type {\
color: #DD4A68\
}\
.ace-prism .ace_operator {\
color: #a67f59;\
}\
.ace-prism .ace_storage {\
color: #07a\
}\
.ace-prism .ace_string {\
color: #690\
}\
.ace-prism .ace_string.ace_regexp,\
.ace-prism .ace_variable,\
.ace-prism .ace_variable.ace_language {\
color: #e90\
}\
.ace-prism .ace_comment,\
.ace-prism .ace_entity.ace_other.ace_attribute-name {\
color: slategray\
}\
.ace-prism .ace_punctuation,\
.ace-prism .ace_paren {\
  color: #999;\
}\
.ace-prism .ace_gutter-cell.ace_error {\
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAs1JREFUSA21Vr9v1DAYtR1uqioOiQW6wMQMw1EGQB1YkO6uKkVCtzD0z4AR/gwGlkqIIjV3FQsSiHagMJT5JliABYmi6qaSmPeSOHEcpzl6hxf7+773vRc7n39IMUX71etdFVqvSiFuol/SUl5kmtT6u5DymxZiD/32ueHwcxMdOOrbYbd7D9GnWusr9agiIqUcw3rUHo1eFd7yyCsIocuAbUJouQyfzoLwPpADCH9xMyqCR93u7UiILYidd8H/YkP0ZyDE+uJo9N7OKwlmYm8g1rJBpx1D9Biid2zRXDBbxk+zzsz9OM4Uvo5ZXmUB+M9mWkaLKx9mnJvGkQge9vvrCHgLBF84VkGwjKV4gKSJSbT6CWMJJq1SK5QOyU0NWukM4/hJBQUHxVqt1srZMPzY3tl5cUapu3DbohP6GCOGWOb4uESmIZNNHccHPhC/mkR27KjXu/Unjl/TR7HF4XDXjv/u96/HUcRtUW1KXVM8QaqR1KOj6JIbowCFfGLE+nJyDp5WqM63WOOV3FkeJEvmzqIMKSxr9guFtxhhud9xhkuFqzJa4PKRqBJxHE1iCRxayhzETr5tNopOJQZGatn70Bb5X2OtkivmZPrG/2gKCTT2lqmwQuuH4n1WiRSORjEDnUoUWiq5PE2W0+ME2fBVKP+Zr5CIZY5Dk5v4h7uc4XbucQYyCL46LmEKpK56fTkWR6j4LKg7jnQcP5+srV0wCUYMNvdZpXqJZY7B2z01Ei06k8M7il7aADMmUCr1kCcIlv8Z/O6m5uG9wZlRDIeI9zmC+P12GG4BmzacOB/qbgyDOW2Pj97HfXiD+fY+HCDAy3KuLeMcGNJckDcy3yAAHJvgrD25yGlue/LlgjT49uAbZB4zJQe57PdMRdCIou8gwX+nEdTQstyOK8a0vGh8HMmzADd1XeW5ORAaC6UesxrdmLFPFDSgeT71/wLEuVamyRQtiQAAAABJRU5ErkJggg==);\
  background-size: 12px 12px;\
  background-position: 4px center;\
  background-repeat: no-repeat;\
  cursor: help;\
}\
.ace-prism .ace_info {\
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAaCAYAAACkVDyJAAAAAXNSR0IArs4c6QAAAmVJREFUSA21Vj1vE0EQ3dmzCR8KInyIjhQUETZIDkX6iCQSBdADNRES7lK5hSr8An4GsUmFgJoi4kMRSqSATA0IgZCC7naHmYv3vLe3a6+FfJLlmXcz73nGe08HYsIr7TZugBbPuA0BHtRv776ahAImKcbetTml1QEiznEfAPxIZo9dhuV3P2N5ZGwh12VadYwY5xSfzX6lHY5jr+gJsdu8pFDvI4oZmxxAHCYgF+DW7lcbD8XREyoUT1wxJiXsuNL6cUjAxaMmxBfNllJ6h8i99QTqRMrrNOV7V8DNoyYksc2QGBOiEJLWvemS+/Kxgunzq6sktuprtjGqWUt7V1ZszBePFKRTyNsa/nIQH2qnL9brdz4Bfzgm0o8FsQLaBPeEr5GCqtu4TwtrDdvhEJbfZCYfxH9NTrWLaqt5b5hXo6Agbt+k4w/l04d4okoBJ0sY0GnOe0tokQQFddZv03rmi0oKQDjkOYYlQe7Raf+R3WfHXkG2MDp5HgeJmJDY6V/s4OvWGVvIxF5B18JMMc1YmmaAVzCaMmh5FUG2MBDYHopYEfgm9GFs7LrNXFZ3HlYEQxbG1fSszdirwu3FC7T6xCUd1Hotr/TMjLMwH/EozGd5pQnHWdgoct89n+UVgrEWVjs1e75wGop9QjbmWl4ueGRHloXZHU4MK2+/G8iODeb9tiwvFzyyI9vCvG3/AZLl9Zp3mQDYhlTW33NdJcTOKzWT4culc9mf399CtTZO7z/9pDa/AGqrsaERn9o3pxVLARuSTtLDaQm4vKxVnFL35rRyiRLX6c3ry7QEDC/9h59RivV/HGMF+tyN9aoAAAAASUVORK5CYII=);\
  background-size: 12px 12px;\
  background-position: 2px center;\
  background-repeat: no-repeat;\
  cursor: help;\
}\
.ace-prism .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWNgYGBgYHjy8NJ/AAjgA5fzQUmBAAAAAElFTkSuQmCC) right repeat-y\
}";
  var dom = acequire("../lib/dom");
  dom.importCssString(exports.cssText, exports.cssClass);
});

/*eslint-disable max-len, spaced-comment*/
var Collapse = /* #__PURE__ */(function () {
  var Collapse = function Collapse() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "02",
      transform: "translate(-1250.000000, -68.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-6",
      transform: "translate(1238.000000, 57.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-14",
      transform: "translate(12.000000, 11.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-4"
    }, /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-7",
      stroke: "#474C4F",
      strokeWidth: "2",
      x: "6",
      y: "6",
      width: "4",
      height: "4"
    }), /*#__PURE__*/React.createElement("g", {
      id: "Group-2",
      transform: "translate(2.000000, 2.000000) rotate(-180.000000) translate(-2.000000, -2.000000) ",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-3",
      transform: "translate(2.000000, 14.000000) rotate(-270.000000) translate(-2.000000, -14.000000) translate(0.000000, 12.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-2",
      transform: "translate(14.000000, 2.000000) rotate(-90.000000) translate(-14.000000, -2.000000) translate(12.000000, 0.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 -4.10271522e-16,0.776142375 -4.4408921e-16,0.5 L-4.4408921e-16,0.5 C-4.77906897e-16,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-4",
      transform: "translate(12.000000, 12.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    }))))))));
  };

  return Collapse;
})();

/*eslint-disable max-len, spaced-comment*/
var Expand = /* #__PURE__ */(function () {
  var Expand = function Expand() {
    return /*#__PURE__*/React.createElement("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "00",
      transform: "translate(-1232.000000, -204.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-6",
      transform: "translate(235.000000, 193.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-14",
      transform: "translate(997.000000, 11.000000)"
    }, /*#__PURE__*/React.createElement("g", {
      id: "Group-4"
    }, /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-7",
      stroke: "#474C4F",
      strokeWidth: "2",
      x: "4",
      y: "4",
      width: "8",
      height: "8"
    }), /*#__PURE__*/React.createElement("g", {
      id: "Group-2",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-3",
      transform: "translate(2.000000, 14.000000) rotate(-90.000000) translate(-2.000000, -14.000000) translate(0.000000, 12.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-2",
      transform: "translate(14.000000, 2.000000) rotate(-270.000000) translate(-14.000000, -2.000000) translate(12.000000, 0.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 -4.10271522e-16,0.776142375 -4.4408921e-16,0.5 L-4.4408921e-16,0.5 C-4.77906897e-16,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    })), /*#__PURE__*/React.createElement("g", {
      id: "Group-2-Copy-4",
      transform: "translate(14.000000, 14.000000) rotate(-180.000000) translate(-14.000000, -14.000000) translate(12.000000, 12.000000)",
      fill: "#474C4F"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M0.5,0 L3.5,0 C3.77614237,-5.07265313e-17 4,0.223857625 4,0.5 L4,0.5 C4,0.776142375 3.77614237,1 3.5,1 L0.5,1 C0.223857625,1 3.38176876e-17,0.776142375 0,0.5 L0,0.5 C-3.38176876e-17,0.223857625 0.223857625,5.07265313e-17 0.5,0 Z",
      id: "Rectangle-15"
    }), /*#__PURE__*/React.createElement("rect", {
      id: "Rectangle-15",
      transform: "translate(0.500000, 2.000000) rotate(-270.000000) translate(-0.500000, -2.000000) ",
      x: "-1.5",
      y: "1.5",
      width: "4",
      height: "1",
      rx: "0.5"
    }))))))));
  };

  return Expand;
})();

var css_248z$1 = ".tb-expand-collapse {\n  position: absolute;\n  z-index: 5;\n  right: 0;\n  top: 0;\n}\n.tb-expand-collapse-button {\n  display: flex;\n  height: 50px;\n  align-items: center;\n  min-width: 40px;\n  padding: 0 12px;\n}\n.tb-expand-collapse-button:hover {\n  cursor: pointer;\n}\n.tb-expand-collapse-button svg {\n  padding: 1px;\n  stroke: #464c4f;\n  margin-right: 7px;\n}\n";
styleInject(css_248z$1);

var css_248z = "/* Alert Colors */\n/* Other Colors */\n/* Syntax Highlighting */\n/* Text Colors */\n/* default text color is @gray1 */\n/*Chart Colors*/\n/* Semantic Colors */\n/* Button Colors */\n.tb-inline {\n  border-bottom: 1px solid #bfbfbe;\n}\n.tb-rich-editor {\n  display: flex;\n  flex-direction: column;\n  flex-flow: column;\n  height: 100%;\n  position: relative;\n}\n.tb-rich-editor-with-border {\n  border: 1px solid #bfbfbe;\n}\n.tb-rich-editor-toolbar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  border-bottom: 1px solid #bfbfbe;\n  min-height: 50px;\n  background-color: #fff;\n}\n.tb-rich-editor-toolbar > * {\n  border-left: 1px solid #bfbfbe;\n}\n.tb-rich-editor-fullscreen {\n  left: 0;\n  background-color: white;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  flex: 1 1 0;\n  z-index: 10;\n  border: 1px solid #bfbfbe;\n  border-bottom: 0;\n}\n.tb-rich-editor-fullscreen-inline {\n  position: fixed;\n  height: calc(100vh - 110px);\n  width: calc(100vw - 40px);\n  top: 110px;\n  z-index: 1010;\n  margin-left: 20px;\n}\n.tb-rich-editor-bottom-gutter {\n  display: flex;\n  flex-direction: row-reverse;\n  padding-right: 2px;\n  background: #f5f2f0;\n  font-family: 'Monaco';\n  font-size: 12px;\n}\n";
styleInject(css_248z);

export { Collapse as C, Expand as E };
//# sourceMappingURL=rich-editor-5bd4b28f.js.map
